export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((reg) => {
          console.log('[SW] Registered:', reg.scope);
          // Check for updates every 60 seconds
          setInterval(() => reg.update(), 60000);
        })
        .catch((err) => console.error('[SW] Registration failed:', err));
    });
  }
}
